<template>
    <div class="platform-page" id="platform-page">        
        <Banner v-for="model in pageStore.getListAs<BannerModel>(page?.elements?.banner?.value)" :model="model" />
        <SmartLinkStandaloneElement :codename="type.elements.content_.codename">
            <div class="content">
                <RichText v-if="!isEmpty(page?.elements?.content_?.value)" :value="page.elements.content_.value" />
            </div>
        </SmartLinkStandaloneElement>
    </div>
    <SocialSharePreviewBlock v-if="page.elements.social_share_preview.value.length > 0" 
                                 :model="pageStore.getLinkedItem<SocialSharePreviewModel>(page.elements.social_share_preview.value[0])"/>
</template>

<script lang="ts" setup>
import { contentTypes, type BannerModel, type PlatformPageModel, type SocialSharePreviewModel } from '~/models';
const type = contentTypes.platform_page;

const pageStore = usePageStore();
const page = pageStore.page as PlatformPageModel;

const {registerItem} = useAnchorNavBar();
registerItem(page.elements.content_.linkedItemCodenames);
</script>